import { Tool } from "@aws-sdk/client-bedrock-runtime";
import { AIChatMessage } from "../../../03_model/ai-chat-message.model";
import { AITool } from "../../../03_model/ai-tool.interface";
import { AssistantSuggestionsComponent } from "./assistant-suggestions.component";

export class AssistantSuggestionsTool implements AITool {

  tool_name = 'display_suggestions';

  description = <Tool>{
    toolSpec: {
      name: this.tool_name,
      description: "Use this tool to display suggestions to the user in a nicely formatted way. The user can then select one of the suggestions, which will trigger a new message to be added to the conversation with the content: 'The user selected the suggestion: \"[suggestion]\"'. This tool should be used when you want to give the user a set of predefined options to choose from.",
      inputSchema: {
        json: {
          type: "object",
          properties: {
            messageText: {
              type: "string",
              description: "An additional free text message to display to the user along with the suggestions to give the user more context.",
            },
            suggestions: {
              type: "array",
              items: {
                type: "string",
              },
              description: "The list of suggestions to display to the user.",
            },
          },
          required: ["suggestions"],
        },
      }
    }
  };

  async invoke({suggestions, messageText}: {suggestions: string[], messageText?: string}): Promise<AIChatMessage> {
    return {
      type: 'component',
      role: 'user',
      component: AssistantSuggestionsComponent,
      contentForLLM: `Tool result: Displaying the following suggestions to the user: ${suggestions.join(', ')}. ${messageText ? `Additional message: ${messageText}` : ''}`,
      data: {
        suggestions,
        messageText,
      },
      requiresFollowUp: false,
    } as AIChatMessage;
  }
}
